import { render, staticRenderFns } from "./OrderDetailsPage.vue?vue&type=template&id=3f7c8596&scoped=true&"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsPage.vue?vue&type=style&index=0&id=3f7c8596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c8596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VTab,VTabItem,VTabs})
